import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

// "חודש שכר" display: a payroll month as "<month name> <year>" in the active language
// (e.g. "ספטמבר 2026"), from the filter's / ApprovalDto's yyyyMM encoding (202609).
// The language comes from TranslateService (what the screen is actually rendered in), not
// GlobalStore.language, which starts out as 'en' regardless of the tenant's language. Impure so
// it follows a runtime language toggle; the formatter is cached per language, so re-runs are cheap.
@Pipe({
  name: 'quePayrollMonth',
  standalone: true,
  pure: false
})
export class PayrollMonthPipe implements PipeTransform {
  #translate = inject(TranslateService);
  #formatters: Record<string, Intl.DateTimeFormat> = {};

  transform(value: number | undefined | null): string | null {
    if (!value) return null;

    const lang = this.#translate.currentLang() || this.#translate.fallbackLang() || 'he';
    const formatter = this.#formatters[lang] ??= new Intl.DateTimeFormat(lang === 'en' ? 'en-US' : 'he-IL', { month: 'long', year: 'numeric' });
    return formatter.format(new Date(Math.floor(value / 100), (value % 100) - 1, 1));
  }
}
